import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse } from './indicacao.types';

export const postIndicacaoDecisao = async (id: number, decisao: 'ACEITA' | 'RECUSADA') => {
	try {
		const response = await BaseClient.post<IndicacaoApiResponse<string>>(
			`v2/Indicacao/Solicitacao/${id}/Decisao`,
			{ decisao }
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<string>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
